import { render, staticRenderFns } from "./CustomEmailAddresses.vue?vue&type=template&id=1352195c&scoped=true&"
import script from "./CustomEmailAddresses.vue?vue&type=script&lang=ts&"
export * from "./CustomEmailAddresses.vue?vue&type=script&lang=ts&"
import style0 from "./CustomEmailAddresses.vue?vue&type=style&index=0&id=1352195c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1352195c",
  null
  
)

export default component.exports